import { useParams } from 'react-router-dom';
import { Form } from '@ant-design/compatible';
import type { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { useCouponGenerate } from '../../../hooks/coupon/useCouponGenerate';
import CouponGenerateNavbar from '../../coupon/generate/CouponGenerateNavbar';
import CouponGenerateUserList from '../../coupon/generate/CouponGenerateUserList';
import CouponGenerateCouponList from '../../coupon/generate/CouponGenerateCouponList';
import CouponGenerateSearchBox from '../../coupon/generate/CouponGenerateSearchBox';
import CouponGenerateSelectedUserList from '../../coupon/generate/CouponGenerateSelectedUserList';
import { CouponGenerateWrapStyle } from './style';

const CouponGenerateWrapInner = (props: { form: WrappedFormUtils }) => {
  const { form } = props;
  const { id } = useParams<{ id: string }>();
  const couponId = id ? Number(id) : undefined;

  const {
    couponGenerate,
    setData,
    toggleModal,
    onCheckIssuedCoupon,
    deleteSelectedIssuedCoupon,
    onCheckUser,
    onSubmit,
    getList,
    getExcelDownload,
  } = useCouponGenerate(couponId);

  const { couponList, issuedUser } = couponGenerate;

  return (
    <CouponGenerateWrapStyle className="coupon-generate-wrap">
      {/* 하단 네브바 */}
      <CouponGenerateNavbar onSubmit={() => onSubmit(form)} toggleModal={toggleModal} />

      {/* 선택된 발급할 쿠폰 리스트 */}
      <CouponGenerateCouponList
        form={form}
        setData={(data: any) =>
          setData({
            path: ['couponGenerate', 'couponList', ...data.path],
            value: data.value,
          })
        }
        toggleModal={toggleModal}
        issuedCouponList={couponList.issuedCouponList}
        selectedCouponIdList={couponList.selectedCouponIdList}
        deleteSelectedIssuedCoupon={deleteSelectedIssuedCoupon}
        onCheckIssuedCoupon={onCheckIssuedCoupon}
      />

      {/* 선택된 유저 리스트 */}
      <CouponGenerateSelectedUserList
        selectedUserIdList={issuedUser.selectedUserIdList}
        selectedUserInfoList={issuedUser.selectedUserInfoList}
        onCheckUser={onCheckUser}
      />

      {/* 쿠폰 발급받을 유저 서치박스 */}
      <CouponGenerateSearchBox
        setData={(data: any) =>
          setData({
            path: ['couponGenerate', 'issuedUser', 'userList', ...data.path],
            value: data.value,
          })
        }
        filterOption={issuedUser.userList.filterOption}
        getList={getList}
      />

      {/* 쿠폰 발급받을 유저 리스트 */}
      <CouponGenerateUserList
        selectedUserIdList={issuedUser.selectedUserIdList}
        list={issuedUser.userList.list}
        pagination={issuedUser.userList.pagination}
        summary={issuedUser.userList.summary}
        getList={getList}
        getExcelDownload={getExcelDownload}
        onCheckUser={onCheckUser}
      />
    </CouponGenerateWrapStyle>
  );
};

export const CouponGenerateWrap = Form.create()(CouponGenerateWrapInner) as React.ComponentType;
